const LIVE_PREFIX = 'https://datagraphics.platform.latimes.com';
const TEST_PREFIX = 'https://datagraphics.latimes-test-dss.caltimes.io';

export const ELECTION_DATE = '2026-11-03';

const USE_LOCAL_FEEDS = false;

const FEED_BASE = USE_LOCAL_FEEDS
  ? '/_workspace/test-feeds'
  : `${LIVE_PREFIX}/election-results-importer/2026`;

//

///////////////////////////////////////////////////////////
/////////////////// AP FEEDS //////////////////////////////
///////////////////////////////////////////////////////////

// STATE_URL contains all CA races, including the U.S. House seats/CD
export const STATE_URL = `${FEED_BASE}/levels/california-${ELECTION_DATE}.json`;
// STATE_NO_FEDERAL_URL is all CA races MINUS Congressional districts b/c they're labeled
// with a "federal" jurisdiction in the data
export const STATE_NO_FEDERAL_URL = `${FEED_BASE}/levels/california-local-${ELECTION_DATE}.json`;
// FEDERAL_URL IS California's U.S. House races only (also in STATE_URL)
export const FEDERAL_URL = `${FEED_BASE}/levels/federal-${ELECTION_DATE}.json`;
// Trends is the power of balance feed
export const TRENDS = `${FEED_BASE}/reports/trends-${ELECTION_DATE}.json`;

///////////////////////////////////////////////////////////
/////////////////// LA COUNTY FEEDS ///////////////////////
///////////////////////////////////////////////////////////
// Races tagged 'ap' are also in STATE_URL; use the AP version of those.

// Countywide, schools, water, judges, etc.
export const LA_COUNTY_URL = `${FEED_BASE}/levels/la-county-${ELECTION_DATE}.json`;

// Cities, including Los Angeles (not in LA_COUNTY_URL)
export const LA_CITY_URL = `${FEED_BASE}/levels/la-city-${ELECTION_DATE}.json`;

///////////////////////////////////////////////////////////
////////// SINGLE RACE FEEDS //////////////////////////////
///////////////////////////////////////////////////////////

// There are individual race files in the /races/ directory in s3,
// so, for embeds where you just need to show one race, or need to combine some from different feeds
// ex: aag hp, then you can make use RACE_URL to build the URL of just that single race
// Find the id id the larger feed and pass that into the function below
/**
 * Individual race file, the only place countyResults appear
 * @param {string} id e.g. 'CA-6123', or an L.A. Vote id like 'sheriff-4348'
 * @param {string} [source] the race's attributes.source: 'ap' (default) or 'lavote'
 */
export const RACE_URL = (id, source = 'ap') =>
  `${FEED_BASE}/races/${source}_${id}_${ELECTION_DATE}.json`;

// single races
// gov
export const CA_GOV_URL = RACE_URL('CA-6123');
// insurance commissioner
export const CA_IC_URL = RACE_URL('CA-6489');
// prop 40 - billionaire tax
export const CA_PROP_40_URL = RACE_URL('CA-84439');
// L.A. mayor
export const LA_MAYOR_URL = RACE_URL('CA-84303');
// L.A. sheriff
export const LA_SHERIFF = RACE_URL('CA-84304');
// L.A. council
export const LA_CD3 = RACE_URL('CA-84459');
export const LA_CD9 = RACE_URL('CA-84460');
// L.A. Measure FD
export const LA_MEAS_FD = RACE_URL('CA-85069');

///////////////
//// OTHER ////
///////////////

// CA map file
export const GEOGRAPHY_URL = `${FEED_BASE}/geo/ca.json`;
